import { render, staticRenderFns } from "./remnantOrder7.vue?vue&type=template&id=5ae21300&scoped=true&"
import script from "./remnantOrder7.vue?vue&type=script&lang=js&"
export * from "./remnantOrder7.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder7.vue?vue&type=style&index=0&id=5ae21300&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae21300",
  null
  
)

export default component.exports